import { render, staticRenderFns } from "./VehicleInspectionAI.vue?vue&type=template&id=d6b17fd0&"
import script from "./VehicleInspectionAI.vue?vue&type=script&lang=js&"
export * from "./VehicleInspectionAI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports